var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"center"},[_c('heads',{staticClass:"head"}),_c('router-view'),_c('foot',{staticClass:"foot"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }